import { createBrowserHistory, createMemoryHistory } from 'history'
import { isAndroidParent } from './util'

// Android WebViews do not properly track history on SPAs
export const AppHistory = isAndroidParent ? createMemoryHistory() : createBrowserHistory()
